import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_BASE_HREF, CurrencyPipe, DatePipe, TitleCasePipe } from '@angular/common';
import { PhonePipe } from './pipes/phone.pipe';
import { FaxPipe } from './pipes/fax.pipe';
import { AddressPipe } from './pipes/address.pipe';
import { NamePipe } from './pipes/name.pipe';
import { ModalComponent } from './components/modal/modal.component';
import { ErrorHandlerComponent } from './components/error-handler/error-handler.component';
import { LoaderInterceptor } from './interceptors/loader.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes), 
    provideClientHydration(), 
    provideHttpClient(withInterceptorsFromDi()), 
    DatePipe, 
    CurrencyPipe, 
    PhonePipe, 
    FaxPipe, 
    AddressPipe, 
    NamePipe, 
    TitleCasePipe,
    {provide: APP_BASE_HREF, useValue: '/mpcv-portal'}, 
    ModalComponent,
    ErrorHandlerComponent,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
  ]
};
